import { render, staticRenderFns } from "./svgViber.vue?vue&type=template&id=a73756ae&scoped=true"
import script from "./svgViber.vue?vue&type=script&lang=js"
export * from "./svgViber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73756ae",
  null
  
)

export default component.exports